import { ChatActions, ChatContextState, ChatViewType } from './chatReducer.types';

export const chatInitialState = (): ChatContextState => ({
  minimizedChatIds: [],
  hasErrorInConnectionToWs: false,
  view: {
    type: ChatViewType.GroupedRooms,
  },
});

export const chatReducer = (state: ChatContextState, action: ChatActions): ChatContextState => {
  switch (action.type) {
    case 'RESET_STATE': {
      return chatInitialState();
    }

    case 'ERROR_CONNECTING_TO_WS': {
      return {
        ...state,
        hasErrorInConnectionToWs: true,
      };
    }

    case 'UPDATE_SELECTED_CHAT': {
      const payload = action.payload;

      if (payload?.chat) {
        const newMinimizedChats =
          payload.minimizeCurrentActiveChat && state.activeChat?.id
            ? [state.activeChat.id, ...state.minimizedChatIds]
            : state.minimizedChatIds;
        const minimizedChatsWithoutCurrent = newMinimizedChats
          .filter((id) => id !== payload.chat?.id)
          .slice(0, 5);

        return {
          ...state,
          activeChat: payload.chat,
          minimizedChatIds: minimizedChatsWithoutCurrent,
        };
      }

      const currentActiveChat = state.activeChat;

      const newMinimizedChats = state.minimizedChatIds.filter((id) => id !== currentActiveChat?.id);

      return {
        ...state,
        activeChat: undefined,
        minimizedChatIds: newMinimizedChats,
      };
    }

    case 'OPEN_ROOMS_OF_GROUP': {
      const { groupMetaId } = action.payload;
      return {
        ...state,
        view: {
          groupMetaId,
          type: ChatViewType.RoomsOfGroup,
        },
      };
    }

    case 'OPEN_CHAT_CREATION':
      return {
        ...state,
        view: {
          type: ChatViewType.PrivateCreation,
        },
      };

    case 'OPEN_GROUP_CHAT_CREATION':
      return {
        ...state,
        view: {
          type: ChatViewType.GroupCreation,
        },
      };

    case 'OPEN_PRIVATE_CHAT': {
      const { chat } = action.payload;

      return {
        ...state,
        activeChat: chat,
      };
    }

    case 'OPEN_GROUPED_ROOMS': {
      return {
        ...state,
        view: {
          type: ChatViewType.GroupedRooms,
        },
      };
    }

    case 'CLOSE_ACTIVE_CHAT': {
      return {
        ...state,
        activeChat: undefined,
      };
    }

    case 'MINIMIZE_ACTIVE_CHAT': {
      if (state.activeChat && state.activeChat.id) {
        const newMinimizedChats = [state.activeChat.id, ...state.minimizedChatIds].slice(0, 5);

        return {
          ...state,
          activeChat: undefined,
          minimizedChatIds: newMinimizedChats,
        };
      }
      return state;
    }

    case 'REMOVE_CHAT_FROM_MINIMIZED': {
      const { chatId } = action.payload;
      const newMinimizedChats = state.minimizedChatIds.filter((id) => id !== chatId);

      return {
        ...state,
        minimizedChatIds: newMinimizedChats,
      };
    }

    case 'ADD_VIDEO_CALL_IN_ACTIVE_CHAT': {
      const { videoCall } = action.payload;

      if (!state.activeChat) {
        return state;
      }

      return {
        ...state,
        activeChat: {
          ...state.activeChat,
          inProgressVideoCall: videoCall,
        },
      };
    }

    case 'DELETE_VIDEO_CALL': {
      if (!state.activeChat) {
        return state;
      }

      return {
        ...state,
        activeChat: {
          ...state.activeChat,
          inProgressVideoCall: undefined,
        },
      };
    }

    default:
      throw new Error('Ação do reducer não encontrada');
  }
};
